export const normalizeWitText = (value) => (value || '')
  .normalize('NFKC')
  .replace(/\s+/g, ' ')
  .trim()
  .toLowerCase();

export const hashWitText = (value) => {
  const normalized = normalizeWitText(value);
  let hash = 5381;
  for (let i = 0; i < normalized.length; i += 1) {
    hash = ((hash << 5) + hash) + normalized.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash).toString(16);
};

const normalizeKeyPart = (value, fallback = 'none') => ((value || fallback)
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '_')
  .replace(/^_+|_+$/g, '') || fallback);

export const createWitTrainingKey = (text, label, trainingKind = 'intent', entityValue = '') => {
  const kindKey = normalizeKeyPart(trainingKind, 'intent');
  if (kindKey === 'entity') {
    const entityTypeKey = normalizeKeyPart(label, 'entity');
    const entityValueKey = normalizeKeyPart(entityValue, 'value');
    return `${kindKey}_${entityTypeKey}_${entityValueKey}_${hashWitText(text)}`;
  }

  const intentKey = normalizeKeyPart(label, 'none');
  return `${intentKey}_${hashWitText(text)}`;
};
